<template>
  <div v-show="show==1" class="product-filter" @click="fadeway">
    <div class="f-main" @click.stop="nothingTodo">
      <div class="f-header">

      </div>
      <div class="f-body">
        <div v-bind:key="levelone.title" class="f-item" v-for='levelone in levelOneItems'>
          <p class="f-title">{{levelone.title}}</p>
          <div class="f-content">
            <div v-bind:key="leveltwo.title" @click="selectItem(levelone,leveltwo.title)" :class="[(selectedItem.get(levelone.title) && selectedItem.get(levelone.title).get(leveltwo.title)==leveltwo.title)?'active':'','f-name']" v-for='leveltwo in levelone.levelTwoItems'>
              {{leveltwo.title}}
 
            </div>
           
          </div>
        </div>
      </div>
      <div class="f-footer">
        <div @click="reset" class="f-reset">重置</div>
        <div @click="ensure" class="f-ensure">确认</div>
      </div>
    </div>
    <popup @hidePopup='hidePopup' v-show='popupShow' :des='popupDes' :type='popupType'/>
  </div>
  
</template>
<style scoped lang="less">
@border: rgb(238, 238, 238);
@blue: #1db6ea;
@fontColor: #999999;
.product-filter {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.1);
  .f-main {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 3rem;
    right: 0;
    background-color: #ffffff;
  }
  .f-header {
    height: 50px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    border-bottom: 1px solid @border;
  }
  .f-body {
    position: absolute;
    top: 50px;
    left: 0;
    right: 0;
    bottom: 50px;
    overflow-y: scroll;
    .f-item {
      border-bottom: 1px solid @border;
      padding: 10px;
      .f-title {
        color: #8a8a8a;
        margin-bottom: 10px;
        font-size: 12px;
      }
      .f-content {
        display: flex;
        flex-wrap: wrap;
        .f-name {
          width: 31%;
          margin-right: 2%;
          height: 30px;
          line-height: 30px;
          text-align: center;
          color: #aaaaaa;
          font-size: 10px;
          border: 1px solid @border;
          margin-bottom: 5px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          &.active {
            border: 1px solid @blue;
            color: @blue;
          }
        }
      }
    }
  }
  .f-footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 45px;
    font-size: 16px;
    .f-reset {
      width: 50%;
      height: 45px;
      line-height: 45px;
      text-align: center;
      float: left;
      color: #ffffff;
      background-color: #c2c3c4;
    }
    .f-ensure {
      width: 50%;
      height: 45px;
      line-height: 45px;
      text-align: center;
      float: left;
      color: #ffffff;
      background-color: @blue;
    }
  }
}
</style>
<script>
import Popup from "./Popup";

export default {
  data() {
    return {
      selectedItem: new Map(),
      resultProducts: new Set(),
      popupShow: false,
      popupDes: "",
      popupType: 4
    };
  },

  mounted() {},

  watch: {
    products: function() {
      this.products.forEach(pd => {
        this.resultProducts.add(pd);
      });
      console.log("total products size", this.products.length);
      // console.log(JSON.stringify(this.resultProducts));
    }
  },

  created() {},

  props: {
    levelOneItems: Array,
    show: Number,
    products: Array
  },

  components: {
    Popup
  },

  // watch:{
  //   checked
  // },

  computed: {},

  methods: {
    reset() {
      this.selectedItem = new Map();
    },

    fadeway() {
      console.log("fade way");
      //this.show=0;
      //alert(this.show);
      this.$emit("fadeway", "hello");
    },

    nothingTodo() {
      console.log("nothing todo");
      // this.$emit('nothingTodo',"hello")
    },

    hidePopup() {
      this.popupShow = false;
    },

    ensure() {
      console.log("selected items ", JSON.stringify(this.selectedItem));

      if (this.selectedItem.size < 1) {
        this.fadeway();
      } else {
        if (this.resultProducts.size > 0) {
          this.$router.push({
            name: "FilterResult",
            params: {
              products: this.resultProducts
            }
          });
        } else {
          this.popupShow = true;
          this.popupDes = "没有满足条件的产品";
        }
      }

      // this.selectedItem = new Map();
    },
    selectItem(levelone, tit2) {
      var newmp = new Map();

      //deep copy for stupid reason!
      this.selectedItem.forEach((val, key) => {
        newmp.set(key, val);
      });

      if (!newmp.has(levelone.title)) {
        newmp.set(levelone.title, new Map());
      }
      //I think isInsideChoice==true means multiple select options
      //Really not sure, just by the sample data
      if (levelone.isInsideChoice == "false") {
        newmp.get(levelone.title).clear();
      }
      newmp.get(levelone.title).set(tit2, tit2);
      console.log("the selectedItem is ", JSON.stringify(newmp));

      //F**k the vue, it only can auto shit for array
      //I have to create new map to make the UI changes by data modification
      this.selectedItem = newmp;

      this.products.forEach(pd => {
        this.resultProducts.add(pd);
      });
      console.log("init the products size",this.resultProducts.size);

      //let's filter
      newmp.forEach((v1, k1) => {
        this.products.forEach(pd => {
          let matched = false;
          if (pd.mapOne.has(k1)) {
            v1.forEach((v2, k2) => {
              if (pd.mapOne.get(k1).has(k2)) {
                matched = true;
              }
            });
          } //end of level two

          if (!matched) {
            this.resultProducts.delete(pd);
          }
        });
      });



      console.log("final list is ", this.resultProducts.size);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/FilterComponent.vue